// imports section Start
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  Drawer,
  Menu,
  MenuItem,
  Typography,
  Grid,
  ListItem,
  ListItemIcon,
  List,
  IconButton,
  Tooltip,
  useMediaQuery,
  ListItemText,
  CardMedia,
} from "@mui/material";
import { HeatPump as HeatPumpIcon } from "@mui/icons-material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux";
import { resetUserParams } from "../../store/ReduxUser";
import { clearCashierCart } from "../../store/ReduxCashierCartReducer";
import * as Icons from "@mui/icons-material";
import { BASEURL } from "../../config/Config";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { useLocation } from "react-router-dom";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import MenuIcon from "@mui/icons-material/Menu";
import { COMPANY_API_01, LOGOUT_API } from "../../api/ApiModel";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import no_image from "../../assets/images/no_image.png";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
const getIconComponent = (iconName) => {
  return Icons[iconName] || Icons["HelpOutline"];
};
// imports section End

function Sidebar({
  mode,
  toggleTheme,
  isMobile,
  isSidebarOpen,
  setSidebarOpen,
}) {
  // Hooks start
  const [anchorEl, setAnchorEl] = useState({});
  const listRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  // Get access rights from the Redux store
  const accessRights = useSelector((state) => state.accessRights);
  const location = useLocation();
  const [isScrolling, setIsScrolling] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeParentMenu, setActiveParentMenu] = useState(null);
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [details, setDetails] = useState(null);

  // const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  const [companyLogoUrl, setCompanyLogoUrl] = useState(null);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPANYLOGO, COMPCODE, USERREFCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  // Handlers start
  const toggleDrawer = () => {
    setSidebarOpen((prev) => !prev);
  };
  const isActiveRoute = (route) => location.pathname === route;

  const activeStyle = {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.buttontxt,
    borderRadius: "8px",
    "&:hover": {
      background: `linear-gradient(135deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.main} 100%)`,
      borderRadius: 1,
    },
    "@media (max-width: 600px)": {
      "&:hover": {
        width: "100%",
      },
    },
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // Fetching company details with specified parameters
      const result = await externalgetApi(COMPANY_API_01, "get", {
        COMPCODE,
        STS: CON_STATUS_ACTIVE,
      });
      // console.log("company", result);
      // Assuming the API returns an array and we want the first item
      if (result) {
        setDetails(result[0]);
        // console.log("result", result);
      } else {
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (COMPANYLOGO) {
      setCompanyLogoUrl(details?.LOGOPATH);
    } else {
      setCompanyLogoUrl(null);
    }
  }, [COMPANYLOGO, details]);

  const parentActiveStyle = {
    boxShadow: 1,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.text.buttontxt,
    borderRadius: "8px",
    "&:hover": {
      background: `linear-gradient(135deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.main} 100%)`,
      borderRadius: 1,
    },
    "@media (max-width: 600px)": {
      "&:hover": {
        width: "100%",
      },
    },
  };

  const companyLogoUrls = COMPANYLOGO ? `${details?.LOGOPATH}` : null;

  const handleLogout = () => {
    dispatch(resetUserParams());
    dispatch(clearCashierCart());
    navigate("/Login");
    setAnchorEl((prev) => ({ ...prev, logout: null }));
  };

  // const handleLogout = async () => {
  //   try {
  //     // Call the Logout API
  //     const logoutPayload = {
  //       compcode: COMPCODE, // Replace with your dynamic compcode
  //       userrefcode: String(USERREFCODE), // Replace with the user's refcode from Redux or state
  //       username: USERNAME, // Replace with the logged-in username from Redux or state
  //     };

  //     const logoutResponse = await externalpostApi(LOGOUT_API, logoutPayload); // Replace LOGOUT_API with the actual endpoint

  //     console.log("logout", logoutResponse);

  //     if (logoutResponse) {
  //       // Logout successful
  //       dispatch(resetUserParams()); // Clear user parameters from Redux
  //       dispatch(clearCashierCart()); // Clear cashier cart or other app states
  //       sessionStorage.clear();
  //       navigate("/Login"); // Redirect to login page
  //       setAnchorEl((prev) => ({ ...prev, logout: null })); // Reset dropdown state if applicable
  //     } else {
  //       console.error("Logout failed:", logoutResponse.message);
  //     }
  //   } catch (error) {
  //     console.error("Error during logout:", error);
  //   }
  // };

  const handleMenuItemClick = (path, parentModuleCode) => {
    navigate(path);
    setActiveSubmenu(path); // Set active submenu
    setActiveParentMenu(parentModuleCode); // Set active parent menu
    setAnchorEl((prev) => ({ ...prev, [parentModuleCode]: null }));
    if (isMobile) {
      setSidebarOpen(false); // Ensure the sidebar closes
    }
  };

  const scrollList = (scrollOffset) => {
    if (listRef.current) {
      listRef.current.scrollBy({
        top: scrollOffset,
        behavior: "smooth",
      });
    }
  };

  // Transform the API response to an array
  const accessRightsArray = Array.isArray(accessRights)
    ? accessRights
    : Object.values(accessRights).filter(
        (item) => item.MODULECODE !== undefined
      );

  useEffect(() => {}, [accessRightsArray]);

  const groupedAccessRights =
    accessRightsArray.length > 0
      ? accessRightsArray.reduce((acc, curr) => {
          const {
            MODULECODE,
            MODULENAME,
            MODMENUNAME,
            ICONPATH,
            ROUTE,
            MAINMENU,
            MAINMENUORDER,
          } = curr;
          if (!acc[MODULECODE]) {
            acc[MODULECODE] = {
              MODULENAME,
              MAINMENU,
              MAINMENUORDER: parseInt(MAINMENUORDER),
              items: [],
            };
          }
          acc[MODULECODE].items.push({ MODMENUNAME, ICONPATH, ROUTE });
          return acc;
        }, {})
      : {};

  const sortedGroupedAccessRights = Object.entries(groupedAccessRights).sort(
    (a, b) => a[1].MAINMENUORDER - b[1].MAINMENUORDER
  );

  const handleScroll = () => {
    setIsScrolling(true);
    clearTimeout(window.scrollTimeout);
    window.scrollTimeout = setTimeout(() => setIsScrolling(false), 500); // Reset after 500ms
  };

  const dynamicStyles = {
    scrollbarVisibility: isScrolling ? "4px" : "0px",
  };

  <Box
    sx={{
      ...styles.sb_box,
      "&::-webkit-scrollbar": {
        width: dynamicStyles.scrollbarVisibility,
      },
    }}
    onScroll={handleScroll}
  />;

  // Handlers end

  return (
    <Box>
      {isMobile && (
        <IconButton
          onClick={toggleSidebar}
          sx={{
            position: { xs: "fixed", sm: "fixed", md: "absolute" },
            top: { xs: 0, sm: 10, md: 10, lg: 10, xl: 10 },
            left: 4,
            zIndex: 10000,
            p: 0,
            color: theme.palette.primary.main,
          }}
        >
          <MenuIcon
            sx={{
              height: 32,
              width: 32,
            }}
          />
        </IconButton>
      )}{" "}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? isSidebarOpen : true}
        anchor="left"
        onClose={toggleSidebar}
        PaperProps={{
          sx: {
            backgroundColor: theme.palette.background.paper,
            color: "text.primary",
            boxShadow: 1,
            // display: "flex",
            // flexDirection: "column",
            // justifyContent: "center",
            alignItems: "center",
            width: isMobile ? "auto" : "auto",
            height: isMobile ? "100vh" : "100vh",
            "@media (max-width: 600px)": {
              alignItems: "flex-start",
            },
          },
        }}
      >
        <Link
          to="/home"
          onClick={() => {
            setActiveSubmenu(null);
            setActiveParentMenu(null);
          }}
        >
          {/* <HeatPumpIcon
            sx={{
              ...styles.sb_heatPumpIcon,
              "@media (max-width: 600px)": {
                display: "none",
              },
            }}
          /> */}

          <CardMedia
            component="img"
            src={companyLogoUrl} // If marriott is static, else use details.COMPCODE based logic
            sx={{
              width: 54,
              height: 54,
              m: 1,
              // maxWidth: "40px",
              mt: 1,
              // mb: 2,
              borderRadius: 1,
              border: `3px solid ${theme.palette.background.paper}`,
              boxShadow: 2,
              transition: "transform 0.3s",
              "&:hover": { transform: "scale(1.1)" },
              "@media (max-width: 600px)": {
                display: "none",
              },
            }}
          />
        </Link>
        <Box
          sx={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <IconButton
            onClick={() => scrollList(-100)} // Scrolls up by 100px
            sx={styles.sb_sideiconButton_up_down}
          >
            <KeyboardDoubleArrowUpIcon />
          </IconButton>
          <Box
            sx={{
              ...styles.sb_box,
              "&::-webkit-scrollbar": {
                width: dynamicStyles.scrollbarVisibility,
              },
            }}
            onScroll={handleScroll}
            ref={listRef}
          >
            <Grid container>
              <Grid item md={6} xs={12} mt={0}>
                <List>
                  {/* {Object.entries(groupedAccessRights).map(
                    ([moduleCode, module]) => ( */}
                  {sortedGroupedAccessRights.map(([moduleCode, module]) => (
                    <React.Fragment key={moduleCode}>
                      <ListItem
                        sx={
                          {
                            // paddingTop: 0,
                          }
                        }
                      >
                        <ListItemIcon
                          sx={{
                            ...(activeParentMenu === moduleCode
                              ? parentActiveStyle
                              : {}),
                            minWidth: "0",
                            "@media (max-width: 600px)": {
                              width: "100%",
                              "&:hover": {
                                width: "100%",
                              },
                            },
                          }}
                        >
                          <Tooltip
                            // title={module.items[0]?.MODMENUNAME || ""}
                            title={module.MAINMENU || ""}
                            arrow
                            placement="right"
                            TransitionProps={{ timeout: 600 }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: theme.palette.primary.main, // Use menuicon color
                                  color: "#fff", // Adjust text color for contrast
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "block",
                                  },
                                },
                              },
                              arrow: {
                                sx: {
                                  color: theme.palette.primary.main, // Match arrow color to tooltip
                                },
                              },
                            }}
                          >
                            <IconButton
                              onClick={(e) =>
                                setAnchorEl((prev) => ({
                                  ...prev,
                                  [moduleCode]: e.currentTarget,
                                }))
                              }
                              sx={styles.sb_sideiconButton}
                            >
                              {/* Render the dynamic icon */}
                              {React.createElement(
                                getIconComponent(module.items[0]?.ICONPATH)
                              )}

                              {/* add is mobile */}
                              {isMobile && (
                                <ListItemText
                                  primary={module.items[0]?.MODMENUNAME}
                                />
                              )}
                            </IconButton>{" "}
                          </Tooltip>

                          <Menu
                            sx={{
                              ...styles.sb_sidemenu,
                              position: "absolute",
                              top: "0",
                              minWidth: "200px",
                            }}
                            id={`menu-${moduleCode}`}
                            anchorEl={anchorEl[moduleCode]}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            open={Boolean(anchorEl[moduleCode])}
                            onClose={() =>
                              setAnchorEl((prev) => ({
                                ...prev,
                                [moduleCode]: null,
                              }))
                            }
                            MenuListProps={{
                              onMouseLeave: () =>
                                setAnchorEl((prev) => ({
                                  ...prev,
                                  [moduleCode]: null,
                                })),
                            }}
                          >
                            {module.items.map((item) => (
                              <MenuItem
                                sx={{
                                  ...styles.sb_sidemenu_menuitem,
                                  ...(isActiveRoute(item.ROUTE)
                                    ? activeStyle
                                    : {}), // Apply active styles
                                }}
                                key={item.ROUTE}
                                onClick={() =>
                                  handleMenuItemClick(item.ROUTE, moduleCode)
                                }
                              >
                                {" "}
                                {/* <CropSquareRoundedIcon
                                    sx={{
                                      minWidth: 16,
                                    }}
                                  /> */}
                                <Typography textAlign="center">
                                  {item.MODMENUNAME}
                                </Typography>
                              </MenuItem>
                            ))}
                          </Menu>
                          {/* Display left arrow if submenu is open */}
                          {anchorEl[moduleCode] && (
                            <PlayArrowRoundedIcon
                              sx={{
                                position: "absolute", // Position the arrow outside the sidebar
                                left: "calc(100% + 20px)", // Position it just outside the submenu
                                // top: "50%",
                                transform: "translateY(-50%)", // Adjust to keep it centered
                                color: theme.palette.primary.main,
                                rotate: "180deg",
                                cursor: "pointer", // Optional: to show it's clickable
                              }}
                              onClick={() =>
                                setAnchorEl((prev) => ({
                                  ...prev,
                                  [moduleCode]: null,
                                }))
                              }
                            />
                          )}
                        </ListItemIcon>
                      </ListItem>
                    </React.Fragment>
                  ))}
                  {/* Logout */}
                </List>
              </Grid>
            </Grid>
          </Box>{" "}
          <IconButton
            onClick={() => scrollList(100)} // Scrolls down by 100px
            sx={styles.sb_sideiconButton_up_down}
          >
            <KeyboardDoubleArrowDownIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <List>
            <ListItem
              sx={{
                padding: 0,
              }}
            >
              <ListItemIcon sx={{ minWidth: "0" }}>
                {/* Logout sidebar */}
                <IconButton
                  onClick={(e) =>
                    setAnchorEl((prev) => ({
                      ...prev,
                      logout: e.currentTarget,
                    }))
                  }
                  sx={styles.sb_sideiconButton}
                >
                  <ExitToAppIcon sx={styles.sb_sideicon} />{" "}
                  {isMobile && <ListItemText primary="Logout" />}
                </IconButton>
                <Menu
                  sx={styles.sb_sidemenu}
                  id="menu-logout"
                  anchorEl={anchorEl.logout}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorEl.logout)}
                  onClose={() =>
                    setAnchorEl((prev) => ({ ...prev, logout: null }))
                  }
                >
             <MenuItem
  sx={styles.sb_sidemenu_menuitem}
  onClick={() => navigate("/")}
>
  Logout
</MenuItem>

                </Menu>
              </ListItemIcon>{" "}
            </ListItem>
          </List>
          <Switch
            sx={styles.Muiswitch}
            onChange={toggleTheme}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Box>
      </Drawer>
    </Box>
  );
}

export default Sidebar;
